import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface KYCINFODialogComponentInterface {
    title: string;
    message:string;
}

@Component({
    templateUrl: 'kyc.informational.dailog.compnent.html'
})

export class KYCINFODialogComponent extends DialogComponent<KYCINFODialogComponentInterface, string> implements KYCINFODialogComponentInterface {
   
    title: string; 
    message:string;   
    
    constructor(private ds: DialogService) {
        super(ds);
    }

    closePopup() {
        this.close();
    }

}




// WEBPACK FOOTER //
// ./src/app/details/kyc/kyc.informational.dailog.compnent.ts